<!--
This form is displayed if the HubSpot EULA form is not able to be loaded.
This could be the case on an air-gapped deployment.
-->
<template>
  <form class="fade-up animate-delay3 mb-6" @keyup.enter="onSubmit">
    <div class="form-group" :class="validation.formGroupClasses('company')">
      <label class="form-control-label" for="company">Company</label>
      <input
        v-model.trim="form.company"
        autofocus
        name="company"
        type="text"
        class="form-control"
        id="company"
        aria-describedby="company"
        placeholder=""
      />
      <div v-if="validation.isInvalid('company')" class="form-control-feedback">
        <IconAlert class="-mt-0.5 mr-2 size-3" />{{ validation.message('company') }}
      </div>
    </div>

    <div class="form-group" :class="validation.formGroupClasses('email')">
      <label class="form-control-label" for="email">E-Mail</label>
      <input
        v-model.trim="form.email"
        name="email"
        type="text"
        class="form-control"
        id="email"
        aria-describedby="email"
        placeholder=""
      />
      <div v-if="validation.isInvalid('email')" class="form-control-feedback">
        <IconAlert class="-mt-0.5 mr-2 size-3" />{{ validation.message('email') }}
      </div>
    </div>

    <BusyButton
      cls="btn btn btn-success"
      :busy="submitting"
      busyText="Submitting..."
      @click="onSubmit"
    >
      <template #content>
        <span>
          <IconCheck class="size-6" />
          Accept</span
        >
      </template>
    </BusyButton>
  </form>
</template>

<style lang="scss" scoped>
.form-pretext {
  font-weight: 700;
  font-size: 0.85rem;
}

form {
  label {
    margin-bottom: 0.6rem;
  }
  input {
    border: none;
    background-color: $color-lightened-100 !important;
    height: 3rem;
    color: white !important;
    &:focus {
      background-color: $color-lightened-150 !important;
    }
  }
  button {
    align-self: flex-start;
    margin-top: 2.3rem;
    line-height: 2;
    padding-left: 3rem;
    padding-right: 3rem;
    width: 100%;
  }
  .has-danger {
    label,
    .form-control-feedback {
      color: #ffab9f !important;
    }
  }
}
@media (max-width: $bp-sm-max) {
  .eula-dialog {
    padding: 1rem;
    width: 100%;
    height: 100%;
  }
  .form-group,
  button {
    width: 100%;
    margin-right: 0 !important;
  }
}
</style>

<script>
import { dashboardBffClient } from '@/api-client';
import BusyButton from '@/components/BusyButton.vue';
import constants from '@/constants';
import formValidation from '@/form-validation';
import * as log from '@/logger';
import * as services from '@/services';
import IconCheck from '~icons/lucide/check';
import IconAlert from '~icons/lucide/triangle-alert';

export default {
  name: 'LocalEulaForm',
  emits: ['accepted'],
  data() {
    return {
      form: this.freshForm(),
      validation: formValidation(),
      submitting: false,
    };
  },
  components: { BusyButton, IconAlert, IconCheck },
  methods: {
    freshForm() {
      return {
        company: '',
        email: '',
      };
    },
    resetForm() {
      this.validation.reset();
      this.form = this.freshForm();
    },
    validateForm() {
      this.validation.reset();
      this.validation.notBlank(this.form.company, 'company');
      this.validation.matchesPattern(
        this.form.email,
        'email',
        constants.regex.EMAIL,
        'Must be a valild email address',
      );
      this.validation.notBlank(this.form.email, 'email');

      return this.validation.formValid();
    },
    onSubmit() {
      if (!this.validateForm()) return;

      const payload = this.form;

      log.info('Posting EULA accept...');
      this.submitting = true;
      dashboardBffClient.eula
        .updateEula(payload)
        .then(() => {
          log.info('EULA accepted.');
          this.$emit('accepted');
        })
        .catch(services.defaultErrorHandler)
        .then(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
